/**
 * Created by bszggg on 2019. 01. 14..
 */
/*
 actualSheet["A1"] = new oCell(actualSheet["A1"]).setBgColor("00FF00");
 */
/*
 Cell Object
 Key 	Description
 v 	raw value (see Data Types section for more info)
 w 	formatted text (if applicable)
 t 	cell type: b Boolean, n Number, e error, s String, d Date
 f 	cell formula (if applicable)
 r 	rich text encoding (if applicable)
 h 	HTML rendering of the rich text (if applicable)
 c 	comments associated with the cell **
 z 	number format string associated with the cell (if requested)
 l 	cell hyperlink object (.Target holds link, .tooltip is tooltip)
 s 	the style/theme of the cell (if applicable)
*/
/**
 * Helper calss to xlsx-style package
 * If you don't put any data here, it will create an empty string object, so after you can set the value and the styles
 * @param val
 * @returns {oCell}
 */
const oCell = function (val) {
    if (typeof val === "undefined") {
        this.val = {
            t: 's',
            v: '',
            r: '<t xml:space="preserve">' + '' + '</t>',
            h: '',
            w: ''
        };
    } else {
        this.val = val;
    }
    return this;
};
/**
 * Set the object value by data, and type
 * @param val
 * @param type -- s string, n number
 * @returns {oCell}
 */
oCell.prototype.setValue = function (val, type) {
    if (typeof type === "undefined") {
        if (typeof val === "number") {
            type = 'n'
        } else {
            type = 's'
        }
    }
    this.val.t = type;
    this.val.h = val;
    this.val.r = val;
    this.val.v = val;
    this.val.w = val;
    return this;
};
oCell.prototype.setFontColor = function (color) {
    if (!this.val) {
        this.val = {};
    }
    if (!this.val.s) {
        this.val.s = {};
    }
    if (!this.val.s.font) {
        this.val.s.font = {};
        this.val.s.font.name = 'Arial';
        this.val.s.font.sz = '10';
    }
    if (!this.val.s.font.color) {
        this.val.s.font.color = {};
    }
    this.val.s.font.color.rgb = 'FF' + color.toUpperCase();
    return this;
};
/**
 * It is just the half of the gradient color
 * @param color
 * @returns {oCell}
 */
oCell.prototype.setBgColor = function (color) {
    if (!this.val) {
        this.val = {};
    }
    if (!this.val.s) {
        this.val.s = {};
    }
    if (!this.val.s.fill) {
        this.val.s.fill = {};
    }
    if (!this.val.s.fill.bgColor) {
        this.val.s.fill.bgColor = {};
        this.val.s.fill.patternType= 'solid';
    }
    this.val.s.fill.bgColor.rgb = 'FF' + color.toUpperCase();
    return this;
};
/**
 * It is the FULL, background color if You use one color to it
 * @param color
 * @returns {oCell}
 */
oCell.prototype.setFBgColor = function (color) {
    this.setFgColor(color);
    this.setBgColor(color);
    return this;
};
/**
 * Foreground color for text. Exactly it is the text color
 * @param color
 * @returns {oCell}
 */
oCell.prototype.setFgColor = function (color) {
    if (!this.val) {
        this.val = {};
    }
    if (!this.val.s) {
        this.val.s = {};
    }
    if (!this.val.s.fill) {
        this.val.s.fill = {};
        this.val.s.fill.patternType= 'solid';
    }
    if (!this.val.s.fill.fgColor) {
        this.val.s.fill.fgColor = {};
    }
    this.val.s.fill.fgColor.rgb = 'FF' + color.toUpperCase();
    return this;
};
/**
 * Get the value object
 * @returns {{}|*|{t: string, v: string, r: string, h: string, w: string}}
 */
oCell.prototype.getValue = function () {
    return this.val;
};

export default oCell;
